import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-no-profile-alert-modal',
  templateUrl: './no-profile-alert-modal.component.html',
  styleUrls: ['./no-profile-alert-modal.component.scss'],
})
export class NoProfileAlertModalComponent {
  @Output() confirmed = new EventEmitter<void>();

  onClickNoPrifleAlert() {
    this.confirmed.emit();
  }
}
